module.exports = __webpack_public_path__ + "static/media/US.2822f086.png";